<ng-container *transloco="let t; read: 'timeSupplements'">
  <ng-container *ngIf="vm$ | async as vm">
    <kendo-grid [data]="timeSupplementReports" scrollable="none">
      <kendo-grid-column
        media="(min-width: 450px)"
        field="timeSupplement.timeFrom"
        title="Von"
        width="150"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          @if(dataItem.timeSupplement != null){
          <span>{{ dataItem.timeSupplement.timeFrom }}</span>
          } @else { 
            {{t('weeklyMaxSupplement.title')}}
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        media="(min-width: 450px)"
        field="timeSupplement.timeTo"
        title="Bis"
        width="150"
      ></kendo-grid-column>
      <kendo-grid-column
        media="(min-width: 450px)"
        field="timeSupplement.percentage"
        title="Prozent"
        width="150"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          @if(dataItem.timeSupplement != null){
          <span>{{ dataItem.timeSupplement.percentage }}</span>
          } @else { 
            {{vm.tenantSettings.weeklyTimeSupplementPercentage}}
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        media="(min-width: 450px)"
        field="flexTimeChange"
        title="Zuschlag"
        width="150"
      ></kendo-grid-column>
    </kendo-grid> </ng-container
></ng-container>
